export default __webpack_public_path__ + "static/media/cloud.05fe2611.png";